import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { id: "job-market" }, " JOBBÖRSE ", -1)
const _hoisted_2 = {
  key: 0,
  class: "job-market container-fluid",
  ref: "root"
}
const _hoisted_3 = { class: "job-market-cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextSectionHeadline = _resolveComponent("TextSectionHeadline")!
  const _component_TextSectionContent = _resolveComponent("TextSectionContent")!
  const _component_TextSection = _resolveComponent("TextSection")!
  const _component_CardEmployer = _resolveComponent("CardEmployer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TextSection, { "spacer-clouds-placement": "bottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_TextSectionHeadline, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_TextSectionContent, null, {
          default: _withCtx(() => [
            _createTextVNode(" Mach dich bereit, einen positiven Beitrag zur Umwelt zu leisten, während du deine Karriere vorantreibst. ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.employers.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employers, (employer, inx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: inx,
                class: "job-market-card"
              }, [
                _createVNode(_component_CardEmployer, { employer: employer }, null, 8, ["employer"])
              ]))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}